'use strict';

import React from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import HolidaysMessage from '@/HolidaysMessage'

import Layout from '@Layout/ECFront'

import Link   from '@Pure/Link'
import Loader from '@Pure/Loader'

export default class OrderConfirmationPage extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			loading: false
		};
	}

	componentWillMount ()
	{
		var component = this;

		app.resetFunctions();

		component.setState(
		{
			loading: true
		});

		qwest.post('/order-confirmation/get')
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			component.setState(
			{
				loading: false
			});

			app.ajaxRedirectLogin(response);

			console.error(error);
		});

		let payment_failed = false;

		payment_failed = document.location.search.split('error=');

		if (payment_failed[1])
		{
			payment_failed = payment_failed[1].split('&')[0];
		}
		else
		{
			payment_failed = false;
		}

		let order = document.location.search.split('order=');

		if (order[1])
		{
			order = order[1].split('&')[0];
		}
		else
		{
			order = undefined;
		}

		if ([true, 'true'].includes(payment_failed) && order)
		{
			qwest.post('/order/payment-failed', { order: order })
			.then(function (xhr, response)
			{
				component.setState(
				{
					loading: false
				});
			})
			.catch(function (error, xhr, response)
			{
				component.setState(
				{
					loading: false
				});

				app.ajaxRedirectLogin(response);

				console.error(error);
			});
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />;
		}

		let message =
		(
			<div className="c-order-success">

				<div className="c-order-success__icon">
					<svg className="o-svg-icon c-order-success__icon-svg">
						<use xlinkHref="/images/icons.svg#svg-icon-success"></use>
					</svg>
				</div>

				<div className="c-order-success__txt">
					Merci, votre commande a bien été enregistrée.
				</div>

				<Link href="/mes-commandes"
					className="c-btn c-order-success__btn">
					<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
						<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
					</svg>
					Mes commandes
				</Link>

				{ loader }
			</div>
		);

		let payment_failed = false;

		payment_failed = document.location.search.split('error=');

		if (payment_failed[1])
		{
			payment_failed = payment_failed[1].split('&')[0];
		}
		else
		{
			payment_failed = false;
		}

		if ([true, 'true'].includes(payment_failed))
		{
			message =
			(
				<div className="c-order-success c-order-success--fail">

					<div className="c-order-success__icon">
						<svg className="o-svg-icon c-order-success__icon-svg">
							<use xlinkHref="/images/icons.svg#svg-icon-fail"></use>
						</svg>
					</div>

					<div className="c-order-success__txt">
						Le paiement n'a pas abouti.
					</div>

					<Link href="/mes-commandes"
						className="c-btn c-order-success__btn">
						<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
						</svg>
						Mes commandes
					</Link>

					{ loader }
				</div>
			);
		}

		var output =
		(
			<Layout page_title="Confirmation de commande" history={ props.history }>

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-content">

						<div className="u-full-width u-text-center">

							{ message }

						</div>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}